<main class="full-height d-flex flex-column justify-content-center text-center container">
  <div class="row">
    <div class="col-8 offset-2 form-group text-center">
      <label class="h2" for="id_idtag" i18n>Enter Table Code</label>
      <input id="id_idtag"
             type="text"
             class="form-control"
             [class.is-valid]="success"
             [class.is-invalid]="error"
             i18n-placeholder
             placeholder="Table Code"
             autofocus
             autocomplete="off"
             [value]="idtag" (keydown)="onKey($event)">
    </div>
  </div>
</main>
